export default __webpack_public_path__ + "static/media/KZ.T.05.2332 black.685e1cb9.svg";